export class FabButtonNextScreenAction {
  static readonly type = '[Navigation] FabButtonNextScreenAction';
}
